import { useAuth } from './useAuth'

export function useProjectsPrivateDefault() {
  const { localUser } = useAuth()
  return Boolean(localUser?.preferences?.projectsPrivateDefault)
}
